import { formatCurrencyServer } from './currency-format.server';
import { formatCurrencyClient } from './currency-format.client';
import { formatNumber } from './number-format';
import { getLocaleClient } from './locale.client';

/**
 * 格式化货币函数
 * @returns `server-side` ((value: number | string) => Promise<string>)
 * @returns `client-side` ((value: number | string) => string)
 */
export const formatPrice = typeof window === 'undefined' ? formatCurrencyServer : formatCurrencyClient;

export * from './locale-check.util';

export { formatCurrencyClient };

export function formatNumberClient(options: Intl.NumberFormatOptions) {
  const locale = getLocaleClient();
  return formatNumber(locale, options);
}
